import { memo, SyntheticEvent, useState } from "react";
import { Tab, TabPane, TabProps } from "semantic-ui-react";

// Components
import CardScannedDocument from "react-lib/apps/HISV3/common/CardScannedDocument";
import CardScanner from "react-lib/apps/HISV3/common/CardScanner";
import { PickedState } from "react-lib/apps/MEH/sequence/PatientQueue";

// Styles
import "./CardMeVitalSign.scss";

type CardMeDocumentProps = {
  //
  runSequence: any;
  setProp: any;
  onEvent: any;
  django: any;
  // Common
  selectedEncounter?: Record<string, any>;
  selectedPatient?: Record<string, any>;
  selectedDivision?: Record<string, any>;
  scannedDocumentController?: any;
  patientData?: Record<string, any>;
  onClose?: (type?: string) => void;
  languageUX: "en" | "th";
} & Pick<PickedState, "loadingStatus">;

const CardMeDocument = (props: CardMeDocumentProps) => {
  const [activeTabIndex, setActiveTabIndex] = useState<number>(0);

  const panes = [
    {
      menuItem: {
        key: "uploadDocument",
        content: (
          <div style={{ alignItems: "center", justifyContent: "center" }}>
            <label>Upload Document</label>
          </div>
        ),
      },
      render: () => (
        <TabPane style={{ height: "100%", overflow: "auto", position: "relative" }}>
          <div style={{ margin: "20px" }}>
            <CardScanner
              isMeBilling={true}
              hideLayOut={true}
              hidePatientIDE={true}
              disabledDocCategory={true}
              onClose={() => props.onClose?.()}
              patientInfo={props.selectedPatient}
              controller={props.scannedDocumentController}
              patientId={props.selectedEncounter?.patient_id}
              encounterId={props.selectedEncounter?.id}
              ownerDivision={props.selectedDivision?.id}
              PATIENT_DATA={props.patientData}
              isGrouped
              onNoPatient={() => props.setProp(`openModScannerError`, true)}
              django={props.django}
              setProp={props.setProp}
              languageUX={props.languageUX}
            />
          </div>
        </TabPane>
      ),
    },
    {
      menuItem: {
        key: "viewDocument",
        content: (
          <div style={{ alignItems: "center", justifyContent: "center" }}>
            <label>View Document</label>
          </div>
        ),
      },
      render: () => (
        <TabPane style={{ height: "100%", overflow: "auto", position: "relative" }}>
          <div style={{ margin: "20px" }}>
            <CardScannedDocument
              key="Common/CardScannedDocument"
              isMeBilling={true}
              hideLayOut={true}
              hidePatientIDE={true}
              disabledDocScanDiv={true}
              disabledDocOwnerDiv={true}
              controller={props.scannedDocumentController}
              patientData={props.patientData}
              patientInfo={{
                ...props.selectedPatient,
                encounter_id: props.selectedEncounter?.id,
              }}
              ownerDivision={props.selectedDivision?.id}
              isGrouped
              django={props.django}
              onClose={() => props.onClose?.()}
              languageUX={props.languageUX}
            />
          </div>
        </TabPane>
      ),
    },
  ];

  const handleChangeTab = (_e: SyntheticEvent, data: TabProps) => {
    setActiveTabIndex(data.activeIndex as number);
  };

  return (
    <div className="card-mevitalsign-main disable-height">
      <Tab
        activeIndex={activeTabIndex}
        menu={{ pointing: true, secondary: true }}
        panes={panes}
        onTabChange={handleChangeTab}
      />
    </div>
  );
};

export default memo(CardMeDocument);
